export function isAnalyticsAllowed(): boolean {
  void window.VLTConsent;
  return true;
}

export function isMarketingAllowed(): boolean {
  void window.VLTConsent;
  return true;
}
